import { Box } from "@mui/material";
import { RailCarLayoutData } from "src/store/api/generatedApi";
import { CameraDirectionItem } from "./CameraDirectionItem";
import { RailCarTrack } from "./railCarLayoutTracks";
import {
  AreaColorMap,
  AreaHotkeyMap,
  AreaMaterialsMap,
} from "./scrapEyeLayoutCommon";

export const RailCarStyleLayout = ({
  layout,
  onSelectArea,
  nonSelectableAreas,
  areaHotkeys,
  areaColors,
  areaMaterials,
  selectedArea,
  isLoadingAreaMaterials,
}: {
  layout: RailCarLayoutData;
  onSelectArea?: (area: string) => void;
  nonSelectableAreas: readonly string[];
  areaHotkeys?: AreaHotkeyMap;
  areaColors?: AreaColorMap;
  areaMaterials?: AreaMaterialsMap;
  selectedArea?: string | null;
  isLoadingAreaMaterials?: boolean;
}) => {
  const orientation = layout.orientation;
  const cameraLabel = layout.camera_direction_label;

  const container = {
    display: "flex",
    flexDirection: orientation === "column" ? "row" : "column",
    gap: orientation === "column" ? 2 : 1,
    p: 4,
    bgcolor: "background.default",
    borderRadius: 1,
    alignItems: orientation === "column" ? "flex-end" : undefined,
  } as const;

  return (
    <Box sx={container}>
      {cameraLabel != null && (
        <Box sx={{ alignSelf: "flex-start", mb: 1 }}>
          <CameraDirectionItem label={cameraLabel} />
        </Box>
      )}
      {layout.tracks.map((track) => (
        <RailCarTrack
          key={track.name}
          track={track}
          onSelectArea={onSelectArea}
          nonSelectableAreas={nonSelectableAreas}
          areaHotkeys={areaHotkeys}
          areaColors={areaColors}
          areaMaterials={areaMaterials}
          selectedArea={selectedArea}
          orientation={orientation}
          isLoadingAreaMaterials={isLoadingAreaMaterials}
        />
      ))}
    </Box>
  );
};
